import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import { addEvent } from "../redux/actions/eventsAction";
import { EVENT_ADD_RESET } from "../redux/constants/eventsConstant";
import { useNavigate } from "react-router-dom";

const AddEventsScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventAddState = useSelector((state) => state.eventAdd);
  const { success } = eventAddState;
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [venue, setVenue] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmitForm = (e) => {
    e.preventDefault();
    dispatch(addEvent(name, date, venue, description));
  };

  useEffect(() => {
    if (success) {
      dispatch({ type: EVENT_ADD_RESET });
      navigate("/events");
    }
  }, [success]);

  return (
    <Layout>
      <PageTitle title="Add New Event" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmitForm}>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Event Name
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Name Of Event"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="example-week-input"
                className="col-sm-2 col-form-label"
              >
                Event Date
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="date"
                  id="example-week-input"
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Event Venue
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Venue"
                  onChange={(e) => setVenue(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Event Description
              </label>
              <div className="col-sm-10">
                <textarea
                  className="form-control"
                  type="text"
                  rows={9}
                  placeholder="Enter Small Description For Event"
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              Add
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default AddEventsScreen;
